

  <ng-container *ngIf="loading; else content">
    <div class="container-with-loading">
      <div class="loading-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </ng-container>

  <ng-template #content>
    <mat-card class="employee-header">
      <div class="header-container">
        <div class="avatar">
          <mat-icon>account_circle</mat-icon>
        </div>

        <div class="info">
          <h2>{{ employee.person.fullName }}</h2>

          <div class="chips">
            <mat-chip color="primary">{{
              employee.position.description
            }}</mat-chip>
            <mat-chip color="accent">{{ employee.area.description }}</mat-chip>
            <mat-chip>{{ employee.division.description }}</mat-chip>
          </div>

          <div class="employee-number">
            Número de empleado: <strong>{{ employee.employeeNumber }}</strong>
          </div>
        </div>
      </div>
    </mat-card>

    <div class="info-cards">
      <!-- Información básica -->
      <mat-card>
        <mat-card-title>
          <mat-icon>badge</mat-icon>
          Información Básica
        </mat-card-title>

        <mat-card-content>
          <p>
            <strong>Fecha nacimiento:</strong>
            {{ employee.person.dateOfBirth | date : "dd/MM/yyyy" }}
          </p>

          <p>
            <strong>Edad:</strong>
            {{ getAge(employee.person.dateOfBirth) }} años
          </p>
        </mat-card-content>
      </mat-card>

      <!-- Contacto -->
      <mat-card>
        <mat-card-title>
          <mat-icon>contact_phone</mat-icon>
          Contacto
        </mat-card-title>

        <mat-card-content>
          <p><strong>Teléfono:</strong> {{ employee.person.telephone }}</p>
          <p><strong>Celular:</strong> {{ employee.person.cellPhone }}</p>
          <p><strong>Email:</strong> {{ employee.person.email }}</p>
        </mat-card-content>
      </mat-card>

      <!-- Información laboral -->
      <mat-card>
        <mat-card-title>
          <mat-icon>work</mat-icon>
          Información Laboral
        </mat-card-title>

        <mat-card-content>
          <p>
            <strong>Salario actual:</strong>
            {{ employee.baseSalary | currency }}
          </p>

          <p><strong>Ubicación:</strong> {{ employee.workLocation }}</p>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-card>
      <mat-card-title>
        <mat-icon>timeline</mat-icon>
        Historial de Posiciones
      </mat-card-title>

      <div class="timeline">
        <div
          class="timeline-item"
          *ngFor="let p of employee.employeePositionHistories"
        >
          <div class="timeline-dot"></div>

          <div class="timeline-content">
            <h4>{{ p.position.description }}</h4>

            <span class="timeline-date">
              {{ p.initDate | date : "dd/MM/yyyy" }}
              -
              {{ p.endDate | date : "dd/MM/yyyy" }}
            </span>

            <p>{{ p.observations }}</p>
          </div>
        </div>
      </div>
    </mat-card>
    <br>
    <mat-card>
      <mat-card-title>
        <mat-icon>payments</mat-icon>
        Historial de Sueldo
      </mat-card-title>

      <table
        mat-table
        [dataSource]="employee.employeeSalaryHistories"
        class="mat-elevation-z1"
      >
        <ng-container matColumnDef="salary">
          <th mat-header-cell *matHeaderCellDef>Salario</th>
          <td mat-cell *matCellDef="let e">
            {{ e.baseSalary | currency }}
          </td>
        </ng-container>

        <ng-container matColumnDef="initDate">
          <th mat-header-cell *matHeaderCellDef>Inicio</th>
          <td mat-cell *matCellDef="let e">
            {{ e.initDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef>Fin</th>
          <td mat-cell *matCellDef="let e">
            {{ e.endDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="salaryColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: salaryColumns"></tr>
      </table>
    </mat-card>
    <br>
    <mat-card>
      <mat-card-title>
        <mat-icon>description</mat-icon>
        Cartas
      </mat-card-title>

      <div class="letters">
        <button
          mat-raised-button
          color="primary"
          (click)="imprimirCarta('LETTER_EMPLOYEE')"
        >
          <mat-icon>print</mat-icon>
          Carta de empleado
        </button>
      </div>
    </mat-card>
  </ng-template>
